import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { StudioState } from '@/store/types/studio.state';
import ColorScaleService from '@/services/ColorScale.service';
import Scale from '@/models/scale';

export const actions: ActionTree<StudioState, RootState> = {
    updateScale( {commit, state}){
        commit('setScale', new Scale(state.baseHue, state.mode));
    },
    updateScaleNotesArray( {commit, state}){
        const nBaseNote = state.notesArray.indexOf(state.baseNote);
        const newNotesArray = [];
        for(let i=0; i<12; i++){
            newNotesArray[i] = state.notesArray[(i+nBaseNote)%12];
        }
        commit('setScaleNotesArray', newNotesArray);
    }
}